<template>
  <div class="footer-top">
    <BaseIconSvg class="footer-top__infermedica_logo" name="logo-purple" />
    <div class="footer-top__icons">
      <a href="https://www.facebook.com/Infermedica/" target="_blank" rel="noopener" class="facebook"><span
          class="sr-only">Facebook link</span>
      </a>
      <a href="https://twitter.com/infermedica" target="_blank" rel="noopener" class="twitter"><span
          class="sr-only">Twitter link</span>
      </a>
      <a href="https://www.linkedin.com/company/infermedica" target="_blank" rel="noopener" class="linkedin"><span
          class="sr-only">LinkedIn link</span>
      </a>
      <a href="https://www.youtube.com/channel/UCCU6bFzXgismpw7Zu7Ygt7w" target="_blank" rel="noopener"
        class="youtube"><span class="sr-only">YouTube link</span>
      </a>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.footer-top {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;

  &__infermedica_logo {
    display: block;
    width: 160px;
    height: 29px;
  }

  &__icons {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    gap: 1px;
    flex-shrink: 0;

    @media (min-width: $breakpoint-sm) {
      gap: 5px;
    }

    @media (min-width: 390px) {
      gap: 12px;
    }
  }

}

.facebook {
  @include icon('@/assets/icons/social-media/24-social-facebook-navy.svg',
    36px,
    36px);

  background-size: auto;
}

.twitter {
  @include icon('@/assets/icons/social-media/24-social-twitter-navy.svg',
    36px,
    36px);

  background-size: 36px;
}

.linkedin {
  @include icon('@/assets/icons/social-media/24-social-linkedin-navy.svg',
    36px,
    36px);

  background-size: auto;
}

.youtube {
  @include icon('@/assets/icons/social-media/24-social-youtube-navy.svg',
    36px,
    36px);

  background-size: auto;
}
</style>
